export const getPlatform = () => {
  const UA = window.navigator.userAgent;
  if (/iPhone|iPad|iPod|iOS|Android/i.test(UA)) {
    return "app";
  }
  return "h5";
};

export const getTerminalType = () => {
  const env = getPlatform();
  let type;
  switch (env) {
    case "app":
      type = /Android/i.test(window.navigator.userAgent)
        ? "android"
        : "ios";
      break;
    default:
      type = "h5";
      break;
  }
  return type;
};
